/*!
=========================================================
* FAX送信
=========================================================
*/
import React from "react";

import {
  Button,
  Row, Col
} from "reactstrap";

import InputText from '../FormParts/InputText'
import GsuiteAuth from '../../components/Auth/GsuiteAuth'
import Request from '../../common/Request'
import ImageControl from '../FormParts/ImageControl'
import format_url from '../../variables/format_url';
import GoogleDrive from  "../../common/GoogleDrive"
import Format from '../../common/Format'
import { GetMessage } from '../../variables/message';

class SendFax extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isConfirm:false,
      data:{
        values:{
          ...props.values,
          name: GsuiteAuth.get('name'),
          user_branch_name: GsuiteAuth.get('user_branch_name'),
          user_branch_fax: GsuiteAuth.get('user_branch_fax'),
          user_tel: GsuiteAuth.get('user_tel') ? GsuiteAuth.get('user_tel').replace(/-/g, '') : '',
          files:[]
        },
        errors:{},
        requiredData:{
          fax_recipient_number: [GetMessage(2024)],
        }
      },
    };

    this.validateCallback = this.validateCallback.bind(this)
    this.sendFex = this.sendFex.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.faxMesseageValidate = this.faxMesseageValidate.bind(this)
    this.state.data.errors = Request.getErrorsFromRequiredData(this.state.data.values, this.state.data.requiredData)

  }
  
  componentDidUpdate(prevProps){
    if(prevProps && JSON.stringify(this.props.data) === JSON.stringify(prevProps.data)){
      return
    }
    this.setState({
      data:{
        ...this.state.data,
        values:{
          ...this.props.values,
          name: GsuiteAuth.get('name'),
          user_branch_name: GsuiteAuth.get('user_branch_name'),
          user_branch_fax: GsuiteAuth.get('user_branch_fax'),
          user_tel: GsuiteAuth.get('user_tel').replace(/-/g, ''),
          files:[]
        },
        errors:Request.getErrorsFromRequiredData(this.props.values, this.state.data.requiredData),
      },
      isConfirm:false,
    })
  }
  
  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:newData
    },()=>callback())
  }

  faxMesseageValidate(user_memo){
    const rows = user_memo.split("\n")
    const splitString = rows.reduce((acc, row)=>{
      let rowArray=[]
      for(var left=row;left.length>37;){
        rowArray.push(left.substring(0,37))
        left=left.substring(37,left.length)
      }
      return [
        ...acc, 
        ...rowArray,
        left
      ]
    },[])
    
    return splitString.splice(0,25).join("\n")
  }
  
  async sendFex(){
    const cutomFaxResponse = await new Promise((resolve, reject)=>{
      const { 
        fax_recipient_name,
        fax_recipient_number,
        user_branch_name,
        name,
        user_branch_fax,
        user_tel,
        user_memo,
        files,
        // user_memo_view
      } = this.state.data.values
      const faxUrl = '/api/pout/K01_FAX'
      const faxParams = {
        format_url: GoogleDrive.getFormatUrl(format_url.K01_FAX),
        format_type:"FAX",
        debug_msg:"",
        object_each_data:{
          NODB__fax_recipient_name: fax_recipient_name || "",
          NODB__fax_recipient_number: fax_recipient_number,
          NODB__user_branch_name: user_branch_name || "",
          NODB__user_name: name || "",
          NODB__user_fax: user_branch_fax || "",
          NODB__user_tel: user_tel || "",
          NODB__user_memo: user_memo || "",
          NODB__filename_list: files.map((file)=>file.name).join(', '),
          
          api_today: Format.dateToString(new Date(),'YYYY年M月D日'),
        },
        files
      }
      Request.post(faxUrl, faxParams, res=>{
        this.props.alertModal.current.confirmCheck({
          title: "処理完了",
          messageNo: 2469
        }, ()=>{
          if(this.props.isModal){
            this.props.toggleModal()
          }
        }, false)
        resolve(res)
      }, err=>{
        this.props.alertModal.current.showErrorModal({messageNo:2470});
        reject(err)
      })
    })
    if (cutomFaxResponse.status===200){
      const sendFaxUrl = '/api/send/FAX'
      Request.post(sendFaxUrl, cutomFaxResponse.Data, res=>{
      }, err=>{
        
      },undefined, true, false, false)
    }
  }

  removeFile(targetIndex){
    const files = this.state.data.values.files.filter((file,index)=>index!==targetIndex)
    this.setState({
      data:{
        ...this.state.data,
        values:{
          ...this.state.data.values,
          files
        }
      }
    })
  }

  render(){
    console.log('state', this.state)
      return <div className="content" style={{fontSize:"0.8rem"}}>
        <div className={!this.props.isModal&&"card"}>
        <div className={!this.props.isModal&&"card-body"}>
          {!this.props.isModal&&<div className="header">
          <span>
            <h5 className="modal-title">■FAX送信</h5>
          </span>
          </div>}
          {this.state.isConfirm?
          <div>
            <Row>
              <Col md="12">
              以下の内容でFAXを送信します。よろしいですか？
              </Col>
            </Row>
            <div className="modal-footer" style={{justifyContent: "space-between"}}>
              <button 
                className="btn btn-secondary"
                onClick={()=>{this.setState({isConfirm:false})}}
              >いいえ</button>
              <Button 
                className="btn btn-info"
                onClick={this.sendFex}
              >はい</Button>
            </div>
            <Col className="input-group-box" style={
              {marginTop:"10px"}
            } md="12">
            <label className="input-group-box-label">宛先情報</label>
            <Row>
              <Col md="6" className="confirm-input">
                <label>宛先名</label>
                <div>
                  <p style={{whiteSpace: "pre-line"}}>
                  {this.state.data.values.fax_recipient_name}
                  </p>
                </div>
              </Col>
              <Col md="6" className="confirm-input">
                <label>Fax番号</label>
                <div>{this.state.data.values.fax_recipient_number}</div>
              </Col>
            </Row>
            </Col>
            <Col className="input-group-box"style={{marginTop:"20px"}} md="12">
            <label className="input-group-box-label">送信者情報</label>
            <Row>
              <Col md="6" className="confirm-input">
                <label>支店名</label>
                <div>{this.state.data.values.user_branch_name}</div>
              </Col>
              <Col md="6" className="confirm-input">
                <label>担当者名</label>
                <div>{this.state.data.values.name}</div>
              </Col>
              <Col md="6" className="confirm-input">
                <label>送信者FAX番号</label>
                <div>{this.state.data.values.user_branch_fax}</div>
              </Col>
              <Col md="6" className="confirm-input">
                <label>送信者電話番号</label>
                <div>{this.state.data.values.user_tel}</div>
              </Col>
            </Row>
            </Col>
            <Col md="12" className="confirm-input">
              <label>送信メッセージ</label>
              <div>
                {/* <p style={{whiteSpace: "pre-line"}}>
                {this.state.data.values.user_memo_view}
                </p> */}
                <p style={{whiteSpace: "pre-line", width:"60ch", maxHeight:(this.props.isModal?"560px":"440px"), margin:"0 0 0 -25px", overflow:"hidden", padding:"5px", border:"1px solid #cad1d7", borderRadius:"10px"}}>
                {this.state.data.values.user_memo}
                </p>
              </div>
            </Col>
            <Col md="12" className="confirm-input">
              <label>送信ファイル名</label>
              <div>{this.state.data.values.files
              &&this.state.data.values.files.length>0
              &&this.state.data.values.files.map((file=>{
                return file.name
              })).join(', ')}</div>
            </Col>
          </div>
          :
          <div>
            <Col className="input-group-box" style={
              {marginTop:"10px"}
            } md="12">
            <label className="input-group-box-label">宛先情報</label>
            <Row>
              <Col md="6">
                <InputText
                  className="mini-scroll"
                  multiline={true}
                  labelOn={true}
                  label='宛先名'
                  name='NODB__fax_recipient_name'
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data}
                  validateType='regist'
                />
              </Col>
              <Col md="6">
                <InputText
                  size={12}
                  labelOn={true}
                  label='Fax番号'
                  name='NODB__fax_recipient_number'
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data}
                  validateType='regist'
                />
              </Col>
            </Row>
              
            </Col>
            <Col className="input-group-box"style={{marginTop:"20px"}} md="12">
            <label className="input-group-box-label">送信者情報</label>
            <Row>
              <Col md="6">
                <InputText
                  labelOn={true}
                  label='支店名'
                  name='USER_BRANCH__user_branch_name'
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data}
                  validateType='regist'
                />
              </Col>
              <Col md="6">
                <InputText
                  labelOn={true}
                  label='担当者名'
                  name='USER__name'
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data}
                  validateType='regist'
                />
              </Col>
              <Col md="6">
                <InputText
                  size={12}
                  labelOn={true}
                  label='送信者FAX番号'
                  name='USER_BRANCH__user_branch_fax'
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data}
                  validateType='regist'
                />
              </Col>
              <Col md="6">
                <InputText
                  size={12}                
                  labelOn={true}
                  label='送信者電話番号'
                  name='USER__user_tel'
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data}
                  validateType='regist'
                />
              </Col>
            </Row>
            </Col>
            <Col md="12">
              <div style={{width:"59ch"}}>
              <InputText multiline={true}
                className="mini-scroll"
                labelOn={true}
                label='送信メッセージ'
                name='NODB__user_memo'
                validateCallback={this.validateCallback} 
                rootData={this.state.data}
                validateType='regist'
              />
              </div>
            </Col>
            <Col md="12">
              <label className="search-text-order">FAX送信ファイル（PDF、画像）</label>
              <div className="file-list-form">
                <Col className={"mini-scroll file-list"+(this.props.isModal?"":" is-not-modal")} md="9">
                  {this.state.data.values.files
                  &&this.state.data.values.files.length>0
                  &&this.state.data.values.files.map((file, index)=>{
                      return <div
                          className="file-list-file"
                          key={index}
                      >{file.name} 
                      <svg 
                          style={{
                              position: "absolute",
                              right: "8px",
                              top: 0,
                              height: "calc(1.7rem)",
                          }}
                          height="20" 
                          width="20" 
                          viewBox="0 0 20 20" 
                          aria-hidden="true" 
                          focusable="false" 
                          className="css-6q0nyr-Svg text-clear-btn"
                          onClick={()=>{this.removeFile(index)}}
                      >
                          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                      </svg>
                      </div>
                  })}
                </Col>
                <Col md="3">
                  <ImageControl
                    accept="image/jpeg,application/pdf"
                    checkMode={"FAX"}
                    gcs_path="temporary"
                    uploadCallback={(croppedImageObject)=>{
                        const {
                          name,
                          id,
                          is_image
                        } = croppedImageObject
                        this.validateCallback({
                          ...this.state.data,
                          values:{
                            ...this.state.data.values,
                            files: [
                              ...this.state.data.values.files?this.state.data.values.files:[],
                              {
                                name:name,
                                file_id:id,
                                is_image
                              }
                            ]
                          }
                        })
                    }}
                    buttonName = {"ファイル追加"}
                    cropData={{
                      unit: '%',
                      width: 30,
                      height: 30,
                    }}
                  />
                </Col>
              </div>
            </Col>
            <Col md="12">
            入力内容でFAXを送信します。よろしいですか？
            </Col>
            <div className="modal-footer">
              {this.props.isModal&&
                <button
                  type="button"
                  class="btn btn-secondary"
                  onClick={this.props.toggleModal}>
                  いいえ
                </button>
              }
              <Button 
                className="btn btn-info"
                onClick={()=>{
                  if (Object.keys(this.state.data.errors).length<1){
                    // this.validateCallback(
                    //   {
                    //     ...this.state.data,
                    //     values:{
                    //       ...this.state.data.values,
                    //       user_memo_view:this.faxMesseageValidate(this.state.data.values.user_memo)
                    //     }
                    //   },()=>this.setState({
                    //     isConfirm:true,
                    //   })
                    // )
                    this.setState({
                      isConfirm:true,
                    })
                  }
                }}
              >はい</Button>
            </div>
          </div>
          }
        </div>
        </div>
      </div>
  }
}

export default SendFax;
